var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeclineModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 174C135.049 174 174 135.049 174 87C174 38.9512 135.049 0 87 0C38.9512 0 0 38.9512 0 87C0 135.049 38.9512 174 87 174Z",
    fill: "#E83647",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2677 67.7322C70.2914 66.7559 68.7085 66.7559 67.7322 67.7322C66.7559 68.7085 66.7559 70.2914 67.7322 71.2677L83.4646 87L67.7322 102.732C66.7559 103.709 66.7559 105.291 67.7322 106.268C68.7085 107.244 70.2914 107.244 71.2677 106.268L87 90.5355L102.732 106.267C103.708 107.244 105.291 107.244 106.267 106.267C107.244 105.291 107.244 103.708 106.267 102.732L90.5355 87L106.267 71.2681C107.244 70.2918 107.244 68.7089 106.267 67.7326C105.291 66.7563 103.708 66.7563 102.732 67.7326L87 83.4646L71.2677 67.7322Z",
    fill: "#E83647"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 174,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeclineModal);
export default __webpack_public_path__ + "static/media/icon-decline-modal.8d15e3605e5525f098e1348ec523710e.svg";
export { ForwardRef as ReactComponent };